import { useState } from "react";
import { copy } from "../copy";
import Icon, { type IconName } from "../components/Icon";

type Props = {
  id: string;
  label: string;
  icon: IconName;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  type?: "text" | "email" | "password";
  autoComplete?: string;
  revealable?: boolean;
};

export default function AuthField({
  id,
  label,
  icon,
  value,
  placeholder,
  onChange,
  type = "text",
  autoComplete,
  revealable = false,
}: Props) {
  const [revealed, setRevealed] = useState(false);
  return (
    <div>
      <label htmlFor={id} className="mb-2 block text-[11px] font-bold uppercase tracking-[0.14em] text-chrome-dim">
        {label}
      </label>
      <div className="flex items-center gap-2 rounded-md border border-ground-edge bg-ground-raised px-3 transition-colors focus-within:border-gold/60">
        <Icon name={icon} className="text-base text-chrome-dim" />
        <input
          id={id}
          name={id}
          type={revealable && revealed ? "text" : type}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          onChange={(e) => onChange(e.target.value)}
          className="h-12 w-full bg-transparent text-sm text-chrome placeholder:text-chrome-dim/70 focus:outline-none"
        />
        {revealable && (
          <button
            type="button"
            onClick={() => setRevealed((v) => !v)}
            aria-label={revealed ? copy.auth.hidePassword : copy.auth.showPassword}
            className="bf-focusable flex h-8 w-8 items-center justify-center rounded-md text-base text-chrome-dim transition-colors hover:text-chrome"
          >
            <Icon name={revealed ? "eyeOff" : "eye"} />
          </button>
        )}
      </div>
    </div>
  );
}
